export const INVOICING_SETTINGS_SECTION_MAX_WIDTH = 600
